import styled from "@emotion/styled";
import { InternalMediaCarousel } from "./InternalMediaCarousel";

export const InternalMediaHomePageInsert = () => {
    return (
        <Container>
            <div className="p-3">
                <div className="mb-4 text-2xl font-bold text-slate-900">
                    Community
                </div>
                <InternalMediaCarousel />
            </div>
        </Container>
    );
};

const Container = styled("div")({
    flexGrow: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column"
});
